import {useState, useEffect, useContext} from "react"
import {UpdateUserContext} from "../../App"
import {color_note, pluriel} from "../Fonctions"
import {shuffleArray} from "../Fonctions"

function evolution (note, noteRef) {
  let msg = ''
  const goodCom = ['😘', '😛', '😋']
  shuffleArray(goodCom)

  const badCom = ['😕', '😱', '😬', '😞', '😓', '😮‍💨']
  shuffleArray(badCom)

  const complimentMax = [
      'Bravo, tu gères un max ! 😎',
      'Bravo, tu assures ! 😎',
      'Bravo, tu es au top ! 😎',
      'Bravo, tu es excellent(e) ! 😎',
      'Bravo, tu es génial(e) ! 😎',
      'Bravo, tu es vraiment très doué(e) ! 😎',
      'Bravo, tu es vraiment très fort(e) ! 😎',
    ]

  if (note === 100) {msg = complimentMax[Math.floor(Math.random() * 7)]}
  else if (note === 0) {msg = 'Il vaut mieux que tu commences par relire ta leçon... 😓'}
  else if (noteRef === 0.1 && note < 40) {msg = 'Ce n\'est pas un très bon début mais tu peux t\'améliorer !'}
  else if (noteRef === 0.1 && note < 60) {msg = 'Ce n\'est pas trop mal mais tu peux t\'améliorer ! 🙂'}
  else if (noteRef === 0.1 && note < 100) {msg = 'C\'est un bon début, continue ainsi ! 😉'}
  else if (note > noteRef) {msg = 'Bravo, tu as progressé, ta note est sauvegardée !' + goodCom[0]}
  else if (note < noteRef) {msg = 'Essaie à nouveau, tu peux faire beaucoup mieux !' + badCom[0]}
  else {msg = 'Tu te maintiens, essaie de progresser encore !'}

  return <span>{msg}</span>
}

export function PPP001 ({auth, setShow_activite, setTab, data_eval, setData_eval}) {
  
  const updateUsercontext = useContext(UpdateUserContext)
  const [annonce, setAnnonce] = useState('')
  const mode_solo = !Object.keys(auth).includes('donne_par')

  const sendData = (auth, delay=0) => {
    //console.log('sendData')
    //console.log(auth)
    fetch("https://maths-au-quotidien.fr/react-automaths/api-database.php", {
        method: 'POST',
        body: JSON.stringify({...auth, action:'sauvegarder', erreur:data_eval.erreur, replayable: mode_solo ? 1:auth.replayable, listeChoix: mode_solo ? '':auth.listeChoix})
      })
      .then(response => response.json())
      .then(data => {
        //console.log(data)
        //return
        updateUsercontext()
      })
      .catch(err => console.log(err))
  }
  const sendStats = (auth) => {
    //console.log('sendStats')
    //console.log(auth)
    fetch("https://maths-au-quotidien.fr/react-automaths/api-database.php", {
        method: 'POST',
        body: JSON.stringify({...auth, action:'statsAddEssaisFull', erreur:data_eval.erreur})
      })
      .then(response => response.json())
      .then(data => {
        //console.log('data Stats =>', data)
        updateUsercontext()
      })
      .catch(err => console.log(err))
  }

  useEffect(()=>{
    /*
      - Comparer le nombre d'essais full avec auth.nbEssaisMin (pour send la note)
      - Si auth.nbEssaisFull > auth.nbEssaisMin alors on sauvegarde la note avec les conditions de la noteRef
      - Si auth.nbEssaisFull < auth.nbEssaisMin alors on avertit "Il vous reste (auth.nbEssaisFull - auth.nbEssaisMin) essais pour sauvegarder la note."
    */
   
    let tryNotes = ''
    let moyenne = -1
    let tryNotesAll = []
    if(auth.nbEssaisMin > 1 && auth.stats.nbEssaisFull < auth.nbEssaisMin-1) {
      tryNotes = auth.stats.tryNotes + (auth.stats.tryNotes ? '__' : '') + auth.note
      setAnnonce('Il te reste ' + (auth.nbEssaisMin - auth.stats.nbEssaisFull - 1) + ' essai'+(pluriel(auth.nbEssaisMin*1 - auth.stats.nbEssaisFull*1 - 1) || '')+' à faire.')
      sendStats({...auth, tryNotes, moyenne})
      //console.log({...auth, tryNotes})
      //console.log('Cas 1')
    } else if(auth.nbEssaisMin > 1 && (auth.stats.nbEssaisFull*1 === auth.nbEssaisMin-1 || auth.note > auth.noteRef)) {
      moyenne = 0
      tryNotes = auth.stats.tryNotes + (auth.stats.tryNotes ? '__' : '') + auth.note
      tryNotesAll = tryNotes.split('__')
      tryNotesAll.forEach(n => moyenne = moyenne + n*1)
      moyenne = Math.round(moyenne*10 / tryNotesAll.length)/10
      //console.log('tryNotesAll => ', tryNotesAll, 'moyenne => ', moyenne)
      //console.log('Cas 2')
      sendStats({...auth, tryNotes, moyenne, note:moyenne})
    } else if(auth.note > auth.noteRef || (auth.note === 0 && auth.noteRef === 0.1) || mode_solo) {
      sendData(auth)
      //console.log('Cas 3')
      //console.log(auth.nbEssaisMin, auth.stats.nbEssaisFull, auth.note, auth.noteRef)
    }
  },[]);

  /*if(auth.nbEssaisMin > 1 && auth.noteRef === 0.1) {
    console.log('Encore ' + (auth.nbEssaisMin - 1) + ' essai' + (pluriel(auth.nbEssaisMin - 1) || '') +' à effectuer pour sauvegarder votre note.')
  }*/

  if(auth.profil !== 'Professeur'){
    setTimeout(e => {
      setShow_activite(false)
      setTab([])
    }, 3000)
  }

  //console.log(auth)
  //console.log(data_eval)
  return (<>
    <div className="page" >
      <div>
      <h1>Fin de l'activité</h1>
      <br/>
    	<div align="center">Fin de la série de {auth.nb_question} questions de niveau {auth.etoile} des activités suivantes :</div>
      <br/>
      <div className="cadre" style={{left:"50%", transform:"translateX(-50%)"}} dangerouslySetInnerHTML={{ __html:auth.title || auth.activite.replaceAll('__', '<br>')}}></div>
      <br/>

      {auth.profil === 'Professeur' ?
        <><input type="button" className="btn" value="Correction" onClick={()=>setData_eval({...data_eval, elt_co:!data_eval.elt_co})} />
          <div className="precedent" onClick={()=>setData_eval({...data_eval, page:data_eval.page-1})}></div>
        </>
        :
        <><div align="center">
            Vous avez obtenu 
            <div className={color_note(auth.note)} style={{fontSize:'1.5em', margin:'10px 0'}} >{auth.note}%</div> 
            de réussite.
            <br/> <br/>

            {evolution(auth.note, auth.noteRef)}
            <br/><br/>
            {annonce}
          </div>
          <br/>
        </>
      }
      </div>
      <br/><br/>
    </div>
    
    </>
  );
}